export default __webpack_public_path__ + "static/media/migsite2.4391c7f4.svg";